module.exports = __webpack_public_path__ + "static/media/Slice26@2x.3fc4ff02.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice26@2x.png
// module id = 1454
// module chunks = 0